import { Config } from './config.type'
const config: Config  = {
    "build": {
        "host": "https://graphql0.canvasflow.io",
        "subdirectory": "/",
        "website": "https://padi.com",
        "subscriptionUrl": "",
        "assetDirectory": "/",
        "title": "Global SIP",
        "shortTitle": "Global SIP",
        "appKey": "39457182-f648-44bf-8f07-b13df8cf15c3",
        "language": "en",
        "languages": [
            "en",
            "de",
            "es",
            "fr",
            "it"
        ],
        "links": {
            "invalidAuthenticationUrl": "https://store.padi.com/en-us/subscription/scuba-diving-magazine-digital-subscription/p/60579-1B2C/"
        },
        "buildNumber": 447417,
        "buildDate": "2026-08-03T15:41:49.602Z",
        "version": "2.11.1"
    },
    "app": {
        "contentProtection": false,
        "admin": true,
        "favorite": false,
        "auth": {
            "enabled": false,
            "type": "login",
            "host": ""
        },
        "hideNavbarOnScroll": false,
        "installationOption": {
            "enabled": false
        },
        "password": {
            "enabled": false,
            "value": ""
        },
        "template": {
            "type": "padi",
            "config": {
                "clientId": "5k9k13qptse1qdcnpa7egk5bem",
                "verificationUrl": "https://piccoloapi.scubadiving.com/offer/recommendation",
                "auth": {
                    "enabled": true,
                    "type": "time",
                    "config": {
                        "reminderTime": 300,
                        "hardStopTime": 300,
                        "signUpUrl": "https://store.padi.com/en-us/subscription/scuba-diving-magazine-digital-subscription/p/60579-1B2C/",
                        "signInUrl": "https://account.padi.com/login/sign-in"
                    }
                }
            }
        },
        "legal": {}
    },
    "issue": {
        "contentType": "responsive-replica",
        "lastLocation": {
            "enabled": false
        }
    },
    "analytics": {
        "tealium": {
            "ChannelID": "",
            "pageType": "",
            "pageDetail": "",
            "pageTemplate": "",
            "projectType": "",
            "url": ""
        },
        "google": {
            "trackerID": "",
            "sampleRate": 1
        },
        "ga4": {
            "trackerID": "",
            "sampleRate": 1
        },
        "gtm": {
            "trackerID": ""
        },
        "gtag": {
            "trackerID": "GTM-54KRDL5"
        },
        "googleOptimize": {
            "trackerID": ""
        },
        "onetrust": {
            "id": ""
        },
        "caymland": {
            "domain": ""
        },
        "ackee": {
            "domainId": "",
            "server": ""
        },
        "netstats": {
            "trackerID": ""
        },
        "hotjar": {
            "trackerID": ""
        },
        "hubspot": {
            "trackerID": ""
        },
        "ShareThis": {
            "trackerID": ""
        },
        "cookiefirst": {
            "key": ""
        },
        "cookiehub": {
            "trackerID": ""
        },
        "plausible": {
            "domain": ""
        },
        "matomo": {
            "urlBase": "",
            "siteId": 5,
            "trackerUrl": "",
            "srcUrl": "",
            "disabled": false,
            "heartBeat": {
                "active": true,
                "seconds": 10
            },
            "linkTracking": false,
            "configurations": {
                "disableCookies": false,
                "setSecureCookie": false,
                "setRequestMethod": "POST"
            }
        }
    }
};
export default config;